@if (name() === 'responsive' && menuItems().length > 0) {
  <div class="p-2 flex flex-row gap-2 w-full justify-center items-center">
    @for (menuItem of menuItems(); track $index + (menuItem?.name ?? '')) {
      <soft-menu-item [menuItem]="menuItem"></soft-menu-item>
    }
  </div>
} @else {
  @for (menuItem of menuItems(); track $index + (menuItem?.name ?? '')) {
    <soft-menu-item [menuItem]="menuItem" class="w-full"></soft-menu-item>
  }
}
